import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { reduxForm } from 'redux-form';
import cx from 'classnames';
import { connect } from 'react-redux';
import numeral from 'numeral';

// contianers
import ResidentialSearchModal from './SearchModal/ResidentialSearchModal';
import RentalSearchModal from './SearchModal/RentalSearchModal';
import LandSearchModal from './SearchModal/LandSearchModal';
import CommercialSearchModal from './SearchModal/CommercialSearchModal';

// modules
import BS from '../../theme/Bootstrap';

const renderPropertyClassForm = props => {
  const { propertyClass } = props;

  switch (propertyClass) {
    case 'rental':
      return <RentalSearchModal {...props} />;
    case 'commercial':
      return <CommercialSearchModal {...props} />;
    case 'land':
      return <LandSearchModal {...props} />;
    case 'residential':
    default:
      return <ResidentialSearchModal {...props} />;
  }
};

let PropertySearchFilterModal = props => {
  const {
    isOpen,
    onToggle,
    totalCount,
    initialValues: { propertyClass = 'residential' }
  } = props;

  return (
    <Modal className={BS.modalDialogFullscreen} isOpen={isOpen} toggle={onToggle}>
      <ModalHeader
        toggle={() => {
          onToggle(false);
        }}
      >
        Reset Filters
      </ModalHeader>
      <ModalBody>
        {renderPropertyClassForm({
          propertyClass,
          ...props
        })}
      </ModalBody>
      <ModalFooter className={BS.p0}>
        <Button className={cx(BS.btnBlock, BS.p3)} color="dark-blue">
          View {numeral(totalCount).format('0,0')} Results
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default reduxForm({
  form: 'property-search-form'
})(
  connect((state, props) => {
    return {
      totalCount: state.PropertySearch.getIn(['list', 'totalCount'])
    };
  })(PropertySearchFilterModal)
);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchFilterModal.js